import { Box, Paper, Typography } from "@mui/material";
import { fabPalette } from "@/setup/theme/fab-palette";
import {
	SawEntryProduct,
	SawRunningProduct,
	SawRunProgress,
} from "../models/types";
import {
	CardBodySx,
	CardPaperSx,
	CardTitle,
	EMPTY,
	InfoGrid,
	NEXT_ACCENT,
	NEXT_ACCENT_DARK,
	PartPairRows,
	SawChip,
} from "./primitives";

type Props = {
	data?: SawRunningProduct | null;
	progress?: SawRunProgress | null;
	// Latest entry scan — the material loaded on the entry to be cut.
	load?: SawEntryProduct | null;
};

// "Current Product" — the part that's running and what's loaded for it. The
// cut itself (tolerance, blade speeds, last length) lives in LiveCutDataCard.
export const RunningProductCard = ({
	data = null,
	progress = null,
	load = null,
}: Props) => (
	<Paper elevation={1} sx={CardPaperSx}>
		<CardTitle
			title="Current Product"
			action={
				<SawChip
					label={`Work Order ${data?.workOrder ?? EMPTY}`}
					accent={fabPalette.primary.main}
					accentDark={fabPalette.primary.dark}
				/>
			}
		/>

		<Box sx={CardBodySx}>
			<PartPairRows
				accent={fabPalette.primary.main}
				part={data?.productNumber}
				ext={data?.extendedPartNumber ?? null}
			/>

			<InfoGrid
				columns={1}
				items={[
					{ label: "Load Part #", value: load?.partNumber ?? null },
					{
						label: "Load Extended Part #",
						value: load?.extendedPartNumber ?? null,
					},
					{ label: "Next Location", value: progress?.nextLocations ?? null },
					{
						label: "Run Progress",
						value: progress
							? `${progress.bundlesCut ?? 0} / ${progress.bundlesTarget ?? EMPTY} bundles · ${progress.piecesCut ?? 0} / ${progress.quantity ?? EMPTY} pcs`
							: null,
					},
				]}
			/>

			{progress?.notes ? (
				<Box
					sx={{
						px: 1,
						py: 0.6,
						borderLeft: `3px solid ${NEXT_ACCENT}`,
						backgroundColor: `${NEXT_ACCENT}1A`,
						borderRadius: 0.5,
					}}
				>
					<Typography
						sx={{
							fontSize: "0.72rem",
							color: NEXT_ACCENT_DARK,
							fontWeight: 600,
						}}
					>
						{progress.notes}
					</Typography>
				</Box>
			) : null}
		</Box>
	</Paper>
);
